import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { BuildingSpaceType } from '../../model/building-space-type';
import { BuildingSpaceTypeService } from '../../service/data/building-space-type.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';

@Component({
    selector: 'app-article-manager',
    templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [StandardCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuildingSpaceTypeManagerComponent extends MultiselectObjectManagerComponentBase<BuildingSpaceType> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: BuildingSpaceTypeService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: StandardCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('BuildingSpaceType');
    this.title = 'BUILDING_SPACE_TYPE.BUILDING_SPACE_TYPES';
    this.preferencesKey = 'rent.building-space-type.list';
  }
}
